import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useLocation } from 'react-router-dom';
import { Icon } from "@iconify/react/dist/iconify.js";
import leftIcon from '@iconify/icons-solar/arrow-left-linear';
import menu from '@iconify/icons-solar/hamburger-menu-broken';
import close from '@iconify/icons-solar/close-circle-line-duotone';

export default function AdminHeader() {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
    const prevUrl = (() => {
        const pathSegments = location.pathname.split('/').filter(Boolean);
        if (pathSegments.length <= 1) {
            return '/';
        } else {
            pathSegments.pop();
            return '/' + pathSegments.join('/');
        }
    })();

    useEffect(() => {
        const handleResize = () => {
            const small = window.innerWidth < 768;
            if (!small) {
                setIsMenuOpen(false);
            }
            setIsSmallScreen(small);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Preserve query parameters when navigating
    const preserveParams = (path) => {
        const params = new URLSearchParams(searchParams);
        return `${path}${params.toString() ? `?${params.toString()}` : ''}`;
    };

    const navLinks = (
        <ul className={`flex gap-8 text-md ${isSmallScreen ? 'flex-col' : 'flex-row justify-end'}`}>
            <li className="text-gray-700 hover:text-gray-900">
              <Link to={preserveParams('/admin/classes')} className={location.pathname.startsWith('/admin/classes') ? 'font-bold' : ''}>Klassen</Link>
            </li>
            <li className="text-gray-700 hover:text-gray-900">
              <Link to={preserveParams('/admin/users')} className={location.pathname.startsWith('/admin/users') ? 'font-bold' : ''}>Nutzer</Link>
            </li>
            <li className="text-gray-700 hover:text-gray-900">
              <Link to={preserveParams('/admin/holidays')} className={location.pathname.startsWith('/admin/holidays') ? 'font-bold' : ''}>Schulfreie Tage</Link>
            </li>
            <li className="text-gray-700 hover:text-gray-900">
              <Link to={preserveParams('/admin/groups')} className={location.pathname.startsWith('/admin/groups') ? 'font-bold' : ''}>Gruppen</Link>
            </li>
            <li className="text-gray-700 hover:text-gray-900">
              <Link to={preserveParams('/admin/topics')} className={location.pathname.startsWith('/admin/topics') ? 'font-bold' : ''}>Themen</Link>
            </li>
        </ul>
    );

    return (
      <nav className="bg-neutral-200 classHeader w-full">
        <div className="container mx-auto p-4 flex justify-between items-center">
           <ul className="flex items-center gap-4">
             <li className="text-gray-700 hover:text-gray-900">
               <Link to={preserveParams(prevUrl)} className="flex items-center text-md">
                 <Icon icon={leftIcon} className="inline-block mr-2" width={22} height={22} />
                 Zurück
               </Link>
             </li>
           </ul>

           {isSmallScreen ? (
               <button onClick={() => setIsMenuOpen(true)} className="text-gray-700 rounded-full hover:bg-neutral-300 p-2">
                   <Icon icon={menu} width={28} height={28} />
               </button>
           ) : (
               navLinks
           )}
         </div>
         {isSmallScreen && isMenuOpen && (
             <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsMenuOpen(false)}></div>
         )}
         {/* Drawer only rendered for small screens and kept out of flow when closed */}
         {isSmallScreen && (
           <div
             role="dialog"
             aria-hidden={!isMenuOpen}
             className={`fixed top-0 right-0 h-full bg-white shadow-lg z-50 p-8 transition-transform transition-opacity transform ${isMenuOpen ? 'translate-x-0 opacity-100 pointer-events-auto' : 'translate-x-full opacity-0 pointer-events-none'} w-64`}
           >
             <button onClick={() => setIsMenuOpen(false)} className="absolute top-4 right-4 text-gray-700 rounded-full hover:bg-gray-100 ">
               <Icon icon={close} width={32} height={32} />
             </button>
             <div className="mt-8">
                 {navLinks}
             </div>
           </div>
         )}
       </nav>
     );
}